export const PAYMENT_CONFIG = {
  monthlyBase: 300,       // Marketing: "$300/month" (= 20 videos × $15)
  videosPerMonth: 20,
  perVideoRate: 15,       // Actual calculation: $15 per approved video
  cpmRate: 3,
  viewThreshold: 10000,
  maxBonusPerVideo: 300,
  bonusPeriod1Days: 30,
  bonusPeriod2Days: 60,
} as const;

export const formatCurrency = (amount: number): string => {
  return `$${amount.toLocaleString()}`;
};

export const formatViews = (views: number): string => {
  return views.toLocaleString();
};
